/* unplugin-vue-components disabled */import { render } from "./StandardPage.vue?vue&type=template&id=07240071&scoped=true"
import script from "./StandardPage.vue?vue&type=script&lang=js"
export * from "./StandardPage.vue?vue&type=script&lang=js"

import "./StandardPage.vue?vue&type=style&index=0&id=07240071&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/quan-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07240071"]])

export default __exports__